<template>
  <div class="sticky-offer">
    <img
      class="absolute image"
      :src="getCompressImage(offerImage)"
      width="80px"
    >
    <div class="title-h4 q-mb-sm offer-title">
      {{ pageData.offerTitle }}
    </div>
    <div class="text-p-tiny q-mb-sm offer-text">
      {{ pageData.offerText }}
    </div>
    <div class="timer flex flex-1 gap-sm q-mb-md">
      <div class="digit-wrapper">
        {{ time.days }}
      </div>
      :
      <div class="digit-wrapper">
        {{ time.hours }}
      </div>
      :
      <div class="digit-wrapper">
        {{ time.minutes }}
      </div>
    </div>
    <BaseButton
      :label="pageData.offerButtonText"
    />
  </div>
  <div
    v-if="showMobileOffer"
    class="sticky-offer-mobile-expanded"
  >
    <div class="relative-position expanded-content">
      <img
        class="absolute image"
        :src="getCompressImage(offerImage)"
        width="140px"
      >
      <AppBtn
        icon="far fa-xmark"
        class="absolute close text-white"
        size="sm"
        @click="showMobileOffer = false"
      />
      <div class="title-h4 q-mb-sm offer-title">
        {{ pageData.offerTitle }}
      </div>
      <div class="text-p-tiny q-mb-sm offer-text">
        {{ pageData.offerText }}
      </div>
      <div class="timer flex gap-md q-mt-md">
        <div class="flex items-center justify-center column">
          <div class="digit-wrapper">
            {{ time.days }}
          </div>
          {{ $t('text.days') }}
        </div>
        <div class="flex items-center justify-center column">
          <div class="digit-wrapper">
            {{ time.hours }}
          </div>
          {{ $t('text.hours') }}
        </div>
        <div class="flex items-center justify-center column">
          <div class="digit-wrapper">
            {{ time.minutes }}
          </div>
          {{ $t('text.minutes') }}
        </div>
      </div>
      <BaseButton
        class="offer-button q-mt-md"
        :label="pageData.offerButtonText"
      />
    </div>
  </div>
  <div
    v-else
    class="sticky-offer-mobile cursor-pointer"
    @click="showMobileOffer = true"
  >
    <div class="image relative-position">
      <img
        :src="offerImage"
        width="100%"
      >
      <div class="clock absolute flex justify-center items-center bg-black">
        <q-icon
          name="far fa-clock"
          size="12px"
          color="white"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import AppBtn from 'components/AppBtn.vue';
import BaseButton from 'components/book-landing/render/BaseButton.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import { ref, computed } from 'vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import getCompressImage from 'src/helpers/getCompressImage';

const props = defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData, timerMinutes } = storeToRefs(bookPageStore);
const {
  offerImage,
} = useBookPageEdit();

const showMobileOffer = ref(false);

const time = computed(() => ((
  props.isPreview
    ? pageData.value.offerDuration
    : {
      days: Math.floor(timerMinutes.value / 1440),
      hours: Math.floor((timerMinutes.value % 1440) / 60),
      minutes: Math.floor(timerMinutes.value % 60),
    }
)));
</script>
